<template>
  <div class="container py-5">

    <p>
    <b> TSK x 2025中華民國美容醫學醫學會 </b>
    <br>誠摯邀請醫美專業人士，與我們共襄盛舉！<br><br><b>📌展會亮點</b>
    <br>✅ 臨床應用剖析 | 探索尖針與鈍針的最新技術發展<br>✅ 現場試用體驗 | 親身感受TSK的極致工藝<br>✅ 專屬參展優惠 | 讓您以最划算的方式升級工具<br><br>📅 展會時間：2025/4/13 (日)<br>📍 展會地點：華南銀行國際會議中心 3樓 B16.17<br><br>不容錯過的醫美盛會，期待您的蒞臨！
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_56.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
